<template>
  <form class="main-modal main-modal_w700" @submit.prevent="addTags">
    <div class="main-modal__title">
      <p>Add tags to order</p>
    </div>

    <div class="main-form__box tags">
      <div
        :ref="`tag_${item.id}`"
        class="tag"
        v-for="item in list"
        :key="item.id"
        @click="setActive(item)"
        :class="{
          tag_active: isActive(item),
        }"
      >
        <svg
          v-if="item.can_use_scooter"
          width="15"
          height="15"
          viewBox="0 0 25 22"
          xmlns="http://www.w3.org/2000/svg"
          style="margin-right: 8px"
        >
          <path
            d="M16.5906 3.45675C17.269 3.45675 17.8189 2.9068 17.8189 2.22841C17.8189 1.55001 17.269 1.00006 16.5906 1.00006C15.9122 1.00006 15.3622 1.55001 15.3622 2.22841C15.3622 2.9068 15.9122 3.45675 16.5906 3.45675Z"
            stroke="#0C0C0C"
            stroke-width="1.4"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M3.74017 18.2914H20.937"
            stroke="#0C0C0C"
            stroke-width="1.4"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M17.3465 5.53552L16.2126 6.95285L17.8189 14.3229H19.2363"
            stroke="#0C0C0C"
            stroke-width="1.4"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12.5276 5.81897H8.55908"
            stroke="#0C0C0C"
            stroke-width="1.4"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M9.78742 9.22052H3.74017"
            stroke="#0C0C0C"
            stroke-width="1.4"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M13.945 12.4331H7.42529"
            stroke="#0C0C0C"
            stroke-width="1.4"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M20.9371 21.0315C22.4504 21.0315 23.6772 19.8047 23.6772 18.2914C23.6772 16.778 22.4504 15.5512 20.9371 15.5512C19.4237 15.5512 18.1969 16.778 18.1969 18.2914C18.1969 19.8047 19.4237 21.0315 20.9371 21.0315Z"
            stroke="#0C0C0C"
            stroke-width="1.4"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M3.74016 21.0315C5.2535 21.0315 6.48032 19.8047 6.48032 18.2914C6.48032 16.778 5.2535 15.5512 3.74016 15.5512C2.22681 15.5512 1 16.778 1 18.2914C1 19.8047 2.22681 21.0315 3.74016 21.0315Z"
            stroke="#0C0C0C"
            stroke-width="1.4"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M17.063 3.26776L20.0866 15.6457"
            stroke="#0C0C0C"
            stroke-width="1.4"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        {{ item.name }}
      </div>
    </div>

    <div class="main-form__buttons main-form__buttons_center">
      <span @click="$emit('close')" class="main-button main-button_cancel">
        {{
        $t("global.cancel")
        }}
      </span>
      <button type="submit" class="main-button main-button_success">{{ $t("global.save") }}</button>
    </div>
  </form>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'tags-to-order',
    props: {
        tags: { required: true },
    },
    computed: {
        ...mapGetters({
            list: 'tags/list',
        }),
    },
    methods: {
        ...mapActions({ fetchTags: 'tags/fetch' }),
        setActive(item) {
            const el = this.$refs[`tag_${item.id}`][0]
            el.classList.toggle('tag_active')

            if (this.tags.find((tag) => tag.id === item.id)) {
                this.tags = this.tags.filter((tag) => tag.id !== item.id)
            } else {
                this.tags.push(item)
            }
        },
        addTags() {
            this.$emit('done', this.tags)
        },
        isActive(item) {
            return this.tags.findIndex((tag) => tag.id === item.id) !== -1
        },
    },
    created() {
        this.fetchTags()
    },
}
</script>
<style lang="scss">
.tags {
  display: flex;
  flex-wrap: wrap;

  .tag {
    padding: 6px 16px;
    margin-right: 8px;
    margin-bottom: 8px;
    border-radius: 4px;
    background-color: var(--bg-color);
    color: var(--menu-text-color);
    border: 1px solid var(--border-color);
    cursor: pointer;
    transition: all 0.3s ease-in;
    position: relative;
    display: flex;
    align-items: center;

    path {
      stroke: var(--menu-text-color);
    }

    &_active {
      background-color: var(--bg-color-green);
      font-weight: bold;
      color: #000;

      path {
        stroke: #000;
      }
    }

    &:hover {
      background-color: var(--bg-color-green);
      font-weight: bold;
      color: #000;

      path {
        stroke: #000;
      }
    }

    &__close {
      position: absolute;
      right: -18px;
      z-index: 3;
    }

    &_mr32 {
      margin-right: 32px;
    }
  }
}
</style>
